import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import "./ProgramsBanner.css";
import { useDonation } from "../Components/DonationContext";
import { useNavigate } from "react-router-dom";
 
// Animation variants for Framer Motion
const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};
 
const staggerItem = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};
 
const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};
 
// Renamed component
const SolidWasteManagement = () => {
  // Data for the initiatives section for cleaner code
  const initiatives = [
    "Development of waste treatment windrows with indigenous technologies.",
    "Waste disposal models designed for Paradeep, Berhampur, and Damanjodi.",
  ];
 
  const { openDonation } = useDonation();
  const navigate = useNavigate();
 
  return (
    <>
      <Header />
 
      {/* Hero Section */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/assets/images/backgrounds/Solid-Waste.png)",
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img src="assets/images/shapes/page-header-shape1.png" alt="" />
        </div>
        <div className="shape2">
          <img src="assets/images/shapes/page-header-shape2.png" alt="" />
        </div>
        <Container>
          <div className="page-header__inner text-center">
            <motion.h2
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Solid Waste Management
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              style={{ color: "#dad2d0", fontSize: "22px", marginTop: "20px" }}
            >
              Vikash supports solid waste management initiatives by promoting waste segregation, recycling, and sustainable disposal practices to ensure cleaner and healthier communities.
            </motion.p>
          </div>
        </Container>
      </section>
 
      {/* Introduction Section (REFRESHED UI) */}
      <section className="py-5" style={{ background: "linear-gradient(180deg, rgba(240,251,245,0.98), rgba(255,255,255,0.95))" }}>
        <Container>
          <style>{`
            .swm-intro-wrap{max-width:1220px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr;gap:32px;align-items:center}
            .swm-intro-panel{background:#fff;border-radius:38px;padding:42px 44px;box-shadow:0 40px 120px rgba(15,122,58,0.08);border:1px solid rgba(15,122,58,0.12);position:relative;overflow:hidden}
            .swm-intro-panel::before{content:'';position:absolute;top:-20px;right:-20px;width:220px;height:220px;border-radius:50%;background:rgba(15,122,58,0.08);filter:blur(16px);pointer-events:none}
            .swm-eyebrow{display:inline-flex;align-items:center;gap:10px;padding:12px 18px;border-radius:999px;background:rgba(15,122,58,0.14);color:#0f7a3a;font-weight:700;font-size:.95rem;margin-bottom:20px}
            .swm-title{font-family:Poppins, sans-serif;font-size:3rem;font-weight:800;color:#0f7a3a;line-height:1.04;margin-bottom:24px}
            .swm-copy{color:#234038;font-size:1.05rem;line-height:1.9;max-width:720px}
            .swm-badges{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px;margin-top:34px}
            .swm-badge{padding:18px 20px;border-radius:24px;background:#eef7ef;color:#0f7a3a;font-weight:700;box-shadow:0 18px 40px rgba(15,122,58,0.06)}
            .swm-media{position:relative;display:flex;flex-direction:column;align-items:center;gap:24px}
            .swm-media::before{content:'';position:absolute;top:-20px;left:-20px;width:220px;height:220px;border-radius:34px;background:rgba(15,122,58,0.12);z-index:0}
            .swm-card{position:relative;z-index:1;border-radius:36px;overflow:hidden;box-shadow:0 34px 105px rgba(15,122,58,0.16);border:1px solid rgba(255,255,255,0.8);width:100%}
            .swm-card img{display:block;width:100%;height:auto;object-fit:cover}
            .swm-card-overlay{position:absolute;bottom:24px;left:24px;background:rgba(255,255,255,0.92);border-radius:24px;padding:16px 18px;box-shadow:0 24px 58px rgba(0,0,0,0.08);max-width:320px}
            .swm-card-overlay span{display:block;color:#0f7a3a;font-weight:700;font-size:.82rem;margin-bottom:8px}
            .swm-card-overlay p{margin:0;color:#2e5044;font-size:.95rem;line-height:1.7}
            .swm-info-panel{width:100%;background:#fff;border-radius:32px;padding:28px 30px;box-shadow:0 24px 72px rgba(15,122,58,0.08);border:1px solid rgba(15,122,58,0.08)}
            .swm-info-panel h3{margin:0 0 14px;color:#0f7a3a;font-size:1.6rem;font-weight:800}
            .swm-info-panel ul{margin:0;padding:0;list-style:none;display:grid;gap:14px}
            .swm-info-panel li{display:flex;align-items:flex-start;gap:12px;color:#334d42;font-size:.98rem;line-height:1.75}
            .swm-info-panel li::before{content:'•';color:#1f8f4d;font-size:1.2rem;line-height:1}
            @media(max-width:980px){.swm-intro-wrap{grid-template-columns:1fr}.swm-badges{grid-template-columns:1fr}.swm-media{flex-direction:column}}
          `}</style>
 
          <div className="swm-intro-wrap">
            <div className="swm-intro-panel">
              <div className="swm-eyebrow">Solid Waste Excellence</div>
              <h2 className="swm-title">Innovative Solutions for a Cleaner Odisha</h2>
              <p className="swm-copy">
                In collaboration with Urban Local Bodies (ULBs) and industrial habitats, Vikash is pioneering effective Solid Waste Management. We have developed innovative waste treatment windrows using indigenous technologies and created tailored waste disposal models for municipalities like Paradeep, Berhampur, and Damanjodi. Our comprehensive model for Urban Solid Waste Management is actively promoted in cities including Bhubaneswar, Berhampur, Paradeep, and Angul.
              </p>
              <div className="swm-badges">
                <div className="swm-badge">Community-led waste programs</div>
                <div className="swm-badge">Regional waste model innovation</div>
              </div>
            </div>
 
            <div className="swm-media">
              <div className="swm-card">
                <img src="/assets/images/sections/SWM.jpg" alt="Solid waste management program" />
                <div className="swm-card-overlay">
                  <span>On-ground implementation</span>
                  <p>Real operations that support cleaner towns and better waste handling systems.</p>
                </div>
              </div>
              <div className="swm-info-panel">
                <h3>Key Solid Waste Focus Areas</h3>
                <ul>
                  <li>Segregation at source and safe collection by trained teams.</li>
                  <li>Indigenous windrow composting for organic waste conversion.</li>
                  <li>Community awareness programs for urban and rural citizens.</li>
                  <li>Partnerships with ULBs for sustainable waste disposal models.</li>
                </ul>
              </div>
            </div>
          </div>
        </Container>
      </section>
 
      {/* Structured Initiatives Section */}
      <section className="py-5" style={{ background: "#ffffff" }}>
        <Container>
          <style>{`
            .swm-initiative-wrap{max-width:1220px;margin:0 auto;display:grid;grid-template-columns:1fr 0.95fr;gap:32px;align-items:start}
            .swm-initiative-panel{background:#f6fcf7;border-radius:34px;padding:36px 40px;box-shadow:0 32px 92px rgba(15,122,58,0.08);border:1px solid rgba(15,122,58,0.08)}
            .swm-initiative-panel h2{margin:0 0 18px;color:#0f7a3a;font-size:2.1rem;font-weight:800}
            .swm-initiative-panel p{margin:0;color:#334d42;font-size:1rem;line-height:1.8}
            .swm-initiative-list{display:grid;gap:22px;margin-top:28px}
            .swm-initiative-card{display:grid;grid-template-columns:72px 1fr;gap:20px;align-items:flex-start;background:#fff;border-radius:28px;padding:28px 30px;box-shadow:0 18px 54px rgba(15,122,58,0.08);transition:transform .3s ease,box-shadow .3s ease}
            .swm-initiative-card:hover{transform:translateY(-6px);box-shadow:0 28px 78px rgba(15,122,58,0.14)}
            .swm-step-circle{width:72px;height:72px;border-radius:24px;background:linear-gradient(180deg,var(--waA),var(--waB));display:flex;align-items:center;justify-content:center;color:#fff;font-weight:800;font-size:1.3rem}
            .swm-initiative-copy{color:#243d35;font-size:1rem;line-height:1.75}
            .swm-side-image{display:flex;flex-direction:column;align-items:flex-start;position:relative;gap:24px}
            .swm-side-image::before{content:'';position:absolute;top:-20px;right:-20px;width:120px;height:120px;border-radius:30px;background:rgba(15,122,58,0.08);filter:blur(18px);}
            .swm-side-image img{position:relative;z-index:1;width:100%;max-width:520px;border-radius:32px;box-shadow:0 26px 80px rgba(15,122,58,0.12)}
            .swm-side-cards{display:grid;grid-template-columns:1fr 1fr;gap:18px;width:100%}
            .swm-side-card{background:#fff;border-radius:28px;padding:22px 24px;box-shadow:0 18px 54px rgba(15,122,58,0.08);border:1px solid rgba(15,122,58,0.08);color:#263f35;line-height:1.75;min-height:130px;display:flex;align-items:center;justify-content:center;text-align:center;font-size:0.98rem}
            @media(max-width:980px){.swm-initiative-wrap{grid-template-columns:1fr}.swm-initiative-panel{padding:28px 24px}.swm-initiative-list{grid-template-columns:1fr}.swm-side-cards{grid-template-columns:1fr}}
          `}</style>
 
          <div className="swm-initiative-wrap">
            <div className="swm-initiative-panel">
              <h2>Our Management Models & Technologies</h2>
              <p>We focus on creating sustainable and locally-adapted waste solutions.</p>
              <div className="swm-initiative-list">
                {initiatives.map((initiative, idx) => (
                  <div key={idx} className="swm-initiative-card">
                    <div className="swm-step-circle">{idx + 1}</div>
                    <div className="swm-initiative-copy">{initiative}</div>
                  </div>
                ))}
              </div>
            </div>
 
            <div className="swm-side-image">
              <img src="/assets/images/sections/SWM.jpg" alt="Solid waste management program" />
              <div className="swm-side-cards">
                <div className="swm-side-card">
                  Waste collection and segregation hubs designed for municipal zones.
                </div>
                <div className="swm-side-card">
                  Community engagement workshops to change behavior around waste disposal.
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
 
      {/* Call To Action Section (Reusable) */}
      <section className="py-5 text-dark" style={{ backgroundColor: "#ffffffff" }}>
        <Container className="text-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
          >
            <h2 className="display-5 fw-bold mb-3">Support a Cleaner Community</h2>
            <p className="lead mb-4">
              Your contribution helps us implement sustainable waste management systems and create healthier environments.
            </p>
            <Button variant="dark" size="lg" className="me-3 fw-bold" onClick={openDonation}>
              Donate
            </Button>
            <Button variant="outline-dark" size="lg" className="fw-bold" onClick={() => navigate("/interns")}>
              Join Us
            </Button>
          </motion.div>
        </Container>
      </section>
 
      <Footer />
 
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};
 
export default SolidWasteManagement;
 